let localization = {
  loginPage: {
    loginTitle: 'Inscription à l\'étude',
    loginSubtitle: 'Veuillez vous connecter avec votre compte Migraine Buddy',
    googleLogin: 'Connexionavec Google',
    emailLogin: 'Connexion avec email',
    or: 'OU',
    email: 'Migraine Buddy Email',
    password: 'Migraine Buddy mot de passe',
    downloadInstructionTitle: 'Vous n\'avez pas de compte Migraine Buddy?',
    downloadInstructionBody:
      `1. Téléchargez Migraine Buddy sur <a style="color: white; text-decoration: underline;" href="https://play.google.com/store/apps/details?id=com.healint.migraineapp&referrer=utm_source=squarestudy" target="_blank">Android</a> ou <a style="color: white; text-decoration: underline;" href="https://itunes.apple.com/app/apple-store/id975074413" target="_blank">iOS</a>
      <br>
      2. Créez un compte avec votre email`
  },
  consentPage: {
    consentTitle: 'Consentement à l\'étude',
    consentBody: 'Veuillez confirmer que vous participez à l\'étude SQUARE et que vous avez lu et signé le formulaire de consentement fourni par votre médecin d’étude. Si vous choisissez d\'associer l\'application Migraine Buddy à l\'étude SQUARE, vos données codées seront partagées avec Novartis via Migraine Buddy, comme indiqué dans le formulaire de consentement.',
    agree: 'Je suis d\'accord',
    disagree: 'Je ne suis pas d\'accord'
  },
  studyIdentifier: {
    studyIdentifierTitle: 'Veuillez donner votre numéro de patient que votre médecin d\'étude vous aura communiqué.',
    studyIdentifierLabel: 'Numéro de patient',
    studyGenderLabel: 'Le sexe',
    studyGenderMale: 'Mâle',
    studyGenderFemale: 'Femelle',
    // studyIdentifierConfirmationTitle: 'Please check that this Study Identifier is correct',
    confirmationTitle: 'S\'il vous plaît vérifier que les informations sont correctes'
  },
  consentManagement: {
    studyName: 'Etude SQUARE',
    studyDescription: `<p>Vous avez associé avec succès votre compte Migraine Buddy à l'étude SQUARE.</p>
<p>Nous souhaitons utiliser ce projet pour étudier l'influence du médicament Aimovig sur la qualité de vie des personnes souffrant de migraine en Suisse.</p>`,
    withdrawConsent: 'Retirer son consentement',
    successWithdrawMessage: 'Vous avez avec succès révoqué votre consentement à lier l\'application Migraine Buddy à l\'essai.',
    withdrawConfirmationHeader: 'Retirer son consentement',
    withdrawConfirmationBody: `<p>Vous retirez votre consentement de lier l'application Migraine Buddy à l'étude SQUARE. Les données déjà collectées sont analysées comme indiqué dans le formulaire de consentement signé. Si vous souhaitez vous retirer complètement de l'étude, veuillez contacter votre médecin de l'étude.</p>`,
    contactInfo: 'Si vous avez des questions sur l\'étude, veuillez contacter votre médecin de l\'étude indiqué dans le formulaire de consentement.'
  },
  global: {
    confirm: 'Confirmer',
    back: 'Retour',
    next: 'Suvant'
  },
  genericMessages: {
    doNotRefresh: 'Pour vous déconnecter, veuillez actualiser la page.',
    genericErrorHeader: 'Pardon! Il semble que quelque chose a mal tourné.',
    genericErrorBody: `<p>Veuillez contacter <a href="mailto:jenny@healint.com" class="primary-color"><u>jenny@healint.com</u></a> ou réessayer plus tard.</p>`
  },
  errorMessages: {
    invalidEmail: 'S\'il vous plaît entrer un email valide.',
    emptyPassword: 'Veuillez entrer votre mot de passe Migraine Buddy.',
    invalidCredentials: 'Cette combinaison d\'adresse électronique et de mot de passe n\'est pas valide. Si vous avez oublié votre mot de passe, réinitialisez-le sur votre application Migraine Buddy.\n.',
    emptyStudyIdentifier: `<p>Veuillez saisir votre numéro de patient.</p>`,
    invalidStudyIdentifier: `<p>Veuillez vérifier que le format de votre numéro de patient est correct.</p>`,
    emptyStudyGender: `<p>S'il vous plaît indiquer votre sexe.</p>`
  }
}

export default localization



// WEBPACK FOOTER //
// ./src/store/localization/frLocalization.js